// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc, DisplayNamedFragmentDoc } from '../../../../fragments/commonFragments.generated';
import { DesignPackageRpoChipFragmentDoc } from '../design-package-configurator/components/DesignPackageItemSlotEditor.generated';
import { AssetInfoFragmentDoc } from '../../../projects/assets/AssetPreview.generated';
import { OptionCombinationsChip_TakeoffLineItemFragmentDoc } from '../design-package-configurator/components/OptionCombinationsChip.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type FinishScheduleDesignPackageQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  versionId: Types.Scalars['ID']['input'];
}>;


export type FinishScheduleDesignPackageQuery = { __typename?: 'Query', designPackage: { __typename?: 'DesignPackage', id: string, name: string, code?: string | null | undefined, location: { __typename?: 'DesignPackageLocationDetail', code: Types.DesignPackageLocation, name: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, name: string, forDesignPackages: boolean, forDesignUpgrade: boolean } }>, combinations: Array<{ __typename?: 'DesignPackageOptionCombination', id: string, name: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string }> }>, planPackages: Array<{ __typename?: 'PlanPackage', id: string, name: string, version: { __typename?: 'ReadyPlanAggregateVersion', id: string } }>, version: { __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined }, aggregateVersions: Array<{ __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined, publishedAt?: Types.Scalars['DateTime']['input'] | null | undefined }> } };

export type FinishScheduleDesignPackageTlisQueryVariables = Types.Exact<{
  filter: Types.DesignPackageFinishScheduleFilter;
  page: Types.PageFilter;
}>;


export type FinishScheduleDesignPackageTlisQuery = { __typename?: 'Query', designPackageFinishSchedule: { __typename?: 'DesignPackageFinishSchedulePageResult', entities: Array<{ __typename?: 'TakeoffLineItem', id: string, quantity?: number | null | undefined, specifications?: string | null | undefined, isDisabledMaterialVariant: boolean, location: { __typename?: 'Location', id: string, name: string, room?: { __typename?: 'Location', id: string, name: string } | null | undefined, feature?: { __typename?: 'Location', id: string, name: string } | null | undefined }, bidItem?: { __typename?: 'BidItem', id: string } | null | undefined, slot: { __typename?: 'ItemSlot', id: string, name: string }, item: { __typename?: 'Item', id: string, name: string, costCode: { __typename?: 'CostCode', id: string, name: string } }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, name: string, designPackageAbbreviation: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, name: string, forDesignUpgrade: boolean, forDesignPackages: boolean, forDesignInterior: boolean, forDesignExterior: boolean, isPlanPackage: boolean, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, name: string, designPackageTagColor?: string | null | undefined } } }>, placeholder?: { __typename?: 'TakeoffLineItem', id: string, targetGroups: Array<{ __typename?: 'ReadyPlanOptionGroup', id: string, name: string, order: number }> } | null | undefined, materialVariant?: { __typename?: 'MaterialVariant', id: string, code: string, modelNumber?: string | null | undefined, manufacturerUrl?: string | null | undefined, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, asset?: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined } | null | undefined } | null | undefined, listing: { __typename?: 'MaterialListing', id: string, name?: string | null | undefined, brand?: { __typename?: 'MaterialBrand', id: string, name: string } | null | undefined }, materialAttributeValues: Array<{ __typename?: 'MaterialAttributeValue', id: string, textValue: string, dimension: { __typename?: 'MaterialAttributeDimension', id: string, name: string, unitOfMeasure?: { __typename?: 'UnitOfMeasure', id: string, abbreviation: string } | null | undefined } }> } | null | undefined, targetGroups: Array<{ __typename?: 'ReadyPlanOptionGroup', id: string, name: string, order: number }>, targetCombinations: Array<{ __typename?: 'DesignPackageOptionCombination', id: string, name: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string }> }>, missingCombinations: Array<{ __typename?: 'DesignPackageOptionCombination', id: string, name: string }> }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, totalCount: number } } };

export type FinishScheduleDesignPackageMetadataQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  dpRpavId: Types.Scalars['ID']['input'];
}>;


export type FinishScheduleDesignPackageMetadataQuery = { __typename?: 'Query', designPackage: { __typename?: 'DesignPackage', id: string, costCodes: Array<{ __typename?: 'CostCode', id: string, name: string }> } };

export type FinishSchedule_DesignPackageFragment = { __typename?: 'DesignPackage', id: string, name: string, code?: string | null | undefined, location: { __typename?: 'DesignPackageLocationDetail', code: Types.DesignPackageLocation, name: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, name: string, forDesignPackages: boolean, forDesignUpgrade: boolean } }>, combinations: Array<{ __typename?: 'DesignPackageOptionCombination', id: string, name: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string }> }>, planPackages: Array<{ __typename?: 'PlanPackage', id: string, name: string, version: { __typename?: 'ReadyPlanAggregateVersion', id: string } }>, version: { __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined }, aggregateVersions: Array<{ __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined, publishedAt?: Types.Scalars['DateTime']['input'] | null | undefined }> };

export type FinishSchedule_ReadyPlanOptionFragment = { __typename?: 'ReadyPlanOption', id: string, name: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, name: string, forDesignPackages: boolean, forDesignUpgrade: boolean } };

export type FinishSchedule_TliFragment = { __typename?: 'TakeoffLineItem', id: string, quantity?: number | null | undefined, specifications?: string | null | undefined, isDisabledMaterialVariant: boolean, location: { __typename?: 'Location', id: string, name: string, room?: { __typename?: 'Location', id: string, name: string } | null | undefined, feature?: { __typename?: 'Location', id: string, name: string } | null | undefined }, bidItem?: { __typename?: 'BidItem', id: string } | null | undefined, slot: { __typename?: 'ItemSlot', id: string, name: string }, item: { __typename?: 'Item', id: string, name: string, costCode: { __typename?: 'CostCode', id: string, name: string } }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, name: string, designPackageAbbreviation: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, name: string, forDesignUpgrade: boolean, forDesignPackages: boolean, forDesignInterior: boolean, forDesignExterior: boolean, isPlanPackage: boolean, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, name: string, designPackageTagColor?: string | null | undefined } } }>, placeholder?: { __typename?: 'TakeoffLineItem', id: string, targetGroups: Array<{ __typename?: 'ReadyPlanOptionGroup', id: string, name: string, order: number }> } | null | undefined, materialVariant?: { __typename?: 'MaterialVariant', id: string, code: string, modelNumber?: string | null | undefined, manufacturerUrl?: string | null | undefined, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, asset?: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined } | null | undefined } | null | undefined, listing: { __typename?: 'MaterialListing', id: string, name?: string | null | undefined, brand?: { __typename?: 'MaterialBrand', id: string, name: string } | null | undefined }, materialAttributeValues: Array<{ __typename?: 'MaterialAttributeValue', id: string, textValue: string, dimension: { __typename?: 'MaterialAttributeDimension', id: string, name: string, unitOfMeasure?: { __typename?: 'UnitOfMeasure', id: string, abbreviation: string } | null | undefined } }> } | null | undefined, targetGroups: Array<{ __typename?: 'ReadyPlanOptionGroup', id: string, name: string, order: number }>, targetCombinations: Array<{ __typename?: 'DesignPackageOptionCombination', id: string, name: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string }> }>, missingCombinations: Array<{ __typename?: 'DesignPackageOptionCombination', id: string, name: string }> };

export type FinishSchedule_MaterialAttributeValueFragment = { __typename?: 'MaterialAttributeValue', id: string, textValue: string, dimension: { __typename?: 'MaterialAttributeDimension', id: string, name: string, unitOfMeasure?: { __typename?: 'UnitOfMeasure', id: string, abbreviation: string } | null | undefined } };

export type FinishSchedule_LocationFragment = { __typename?: 'Location', id: string, name: string, room?: { __typename?: 'Location', id: string, name: string } | null | undefined, feature?: { __typename?: 'Location', id: string, name: string } | null | undefined };

export const FinishSchedule_ReadyPlanOptionFragmentDoc = gql`
    fragment FinishSchedule_ReadyPlanOption on ReadyPlanOption {
  id
  name
  optionGroup {
    id
    name
    forDesignPackages
    forDesignUpgrade
  }
}
    `;
export const FinishSchedule_DesignPackageFragmentDoc = gql`
    fragment FinishSchedule_DesignPackage on DesignPackage {
  id
  name
  code
  location {
    code
    name
  }
  options {
    ...FinishSchedule_ReadyPlanOption
  }
  combinations {
    id
    name
    options {
      id
    }
  }
  planPackages {
    id
    name
    version {
      id
    }
  }
  version {
    id
    version
  }
  aggregateVersions {
    id
    version
    publishedAt
  }
}
    ${FinishSchedule_ReadyPlanOptionFragmentDoc}`;
export const FinishSchedule_LocationFragmentDoc = gql`
    fragment FinishSchedule_Location on Location {
  ...Named
  room {
    ...Named
  }
  feature {
    ...Named
  }
}
    ${NamedFragmentDoc}`;
export const FinishSchedule_MaterialAttributeValueFragmentDoc = gql`
    fragment FinishSchedule_MaterialAttributeValue on MaterialAttributeValue {
  id
  textValue
  dimension {
    id
    name
    unitOfMeasure {
      id
      abbreviation
    }
  }
}
    `;
export const FinishSchedule_TliFragmentDoc = gql`
    fragment FinishSchedule_Tli on TakeoffLineItem {
  id
  quantity
  location {
    ...FinishSchedule_Location
  }
  specifications
  isDisabledMaterialVariant
  bidItem {
    id
  }
  slot {
    ...Named
  }
  item {
    ...Named
    costCode {
      ...Named
    }
  }
  options {
    ...DesignPackageRpoChip
  }
  placeholder {
    id
  }
  materialVariant {
    id
    code
    modelNumber
    manufacturerUrl
    featuredImage {
      id
      asset {
        ...AssetInfo
      }
    }
    listing {
      id
      name
      brand {
        id
        name
      }
    }
    materialAttributeValues {
      ...FinishSchedule_MaterialAttributeValue
    }
  }
  ...OptionCombinationsChip_TakeoffLineItem
}
    ${FinishSchedule_LocationFragmentDoc}
${NamedFragmentDoc}
${DesignPackageRpoChipFragmentDoc}
${AssetInfoFragmentDoc}
${FinishSchedule_MaterialAttributeValueFragmentDoc}
${OptionCombinationsChip_TakeoffLineItemFragmentDoc}`;
export const FinishScheduleDesignPackageDocument = gql`
    query FinishScheduleDesignPackage($id: ID!, $versionId: ID!) {
  designPackage(id: $id, versionId: $versionId) {
    ...FinishSchedule_DesignPackage
  }
}
    ${FinishSchedule_DesignPackageFragmentDoc}`;

/**
 * __useFinishScheduleDesignPackageQuery__
 *
 * To run a query within a React component, call `useFinishScheduleDesignPackageQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinishScheduleDesignPackageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinishScheduleDesignPackageQuery({
 *   variables: {
 *      id: // value for 'id'
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useFinishScheduleDesignPackageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FinishScheduleDesignPackageQuery, FinishScheduleDesignPackageQueryVariables> & ({ variables: FinishScheduleDesignPackageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FinishScheduleDesignPackageQuery, FinishScheduleDesignPackageQueryVariables>(FinishScheduleDesignPackageDocument, options);
      }
export function useFinishScheduleDesignPackageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FinishScheduleDesignPackageQuery, FinishScheduleDesignPackageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FinishScheduleDesignPackageQuery, FinishScheduleDesignPackageQueryVariables>(FinishScheduleDesignPackageDocument, options);
        }
export function useFinishScheduleDesignPackageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FinishScheduleDesignPackageQuery, FinishScheduleDesignPackageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FinishScheduleDesignPackageQuery, FinishScheduleDesignPackageQueryVariables>(FinishScheduleDesignPackageDocument, options);
        }
export type FinishScheduleDesignPackageQueryHookResult = ReturnType<typeof useFinishScheduleDesignPackageQuery>;
export type FinishScheduleDesignPackageLazyQueryHookResult = ReturnType<typeof useFinishScheduleDesignPackageLazyQuery>;
export type FinishScheduleDesignPackageSuspenseQueryHookResult = ReturnType<typeof useFinishScheduleDesignPackageSuspenseQuery>;
export type FinishScheduleDesignPackageQueryResult = Apollo.QueryResult<FinishScheduleDesignPackageQuery, FinishScheduleDesignPackageQueryVariables>;
export const FinishScheduleDesignPackageTlisDocument = gql`
    query FinishScheduleDesignPackageTlis($filter: DesignPackageFinishScheduleFilter!, $page: PageFilter!) {
  designPackageFinishSchedule(filter: $filter, page: $page) {
    entities {
      ...FinishSchedule_Tli
    }
    pageInfo {
      hasNextPage
      totalCount
    }
  }
}
    ${FinishSchedule_TliFragmentDoc}`;

/**
 * __useFinishScheduleDesignPackageTlisQuery__
 *
 * To run a query within a React component, call `useFinishScheduleDesignPackageTlisQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinishScheduleDesignPackageTlisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinishScheduleDesignPackageTlisQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useFinishScheduleDesignPackageTlisQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FinishScheduleDesignPackageTlisQuery, FinishScheduleDesignPackageTlisQueryVariables> & ({ variables: FinishScheduleDesignPackageTlisQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FinishScheduleDesignPackageTlisQuery, FinishScheduleDesignPackageTlisQueryVariables>(FinishScheduleDesignPackageTlisDocument, options);
      }
export function useFinishScheduleDesignPackageTlisLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FinishScheduleDesignPackageTlisQuery, FinishScheduleDesignPackageTlisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FinishScheduleDesignPackageTlisQuery, FinishScheduleDesignPackageTlisQueryVariables>(FinishScheduleDesignPackageTlisDocument, options);
        }
export function useFinishScheduleDesignPackageTlisSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FinishScheduleDesignPackageTlisQuery, FinishScheduleDesignPackageTlisQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FinishScheduleDesignPackageTlisQuery, FinishScheduleDesignPackageTlisQueryVariables>(FinishScheduleDesignPackageTlisDocument, options);
        }
export type FinishScheduleDesignPackageTlisQueryHookResult = ReturnType<typeof useFinishScheduleDesignPackageTlisQuery>;
export type FinishScheduleDesignPackageTlisLazyQueryHookResult = ReturnType<typeof useFinishScheduleDesignPackageTlisLazyQuery>;
export type FinishScheduleDesignPackageTlisSuspenseQueryHookResult = ReturnType<typeof useFinishScheduleDesignPackageTlisSuspenseQuery>;
export type FinishScheduleDesignPackageTlisQueryResult = Apollo.QueryResult<FinishScheduleDesignPackageTlisQuery, FinishScheduleDesignPackageTlisQueryVariables>;
export const FinishScheduleDesignPackageMetadataDocument = gql`
    query FinishScheduleDesignPackageMetadata($id: ID!, $dpRpavId: ID!) {
  designPackage(id: $id, versionId: $dpRpavId) {
    id
    costCodes {
      ...Named
    }
  }
}
    ${NamedFragmentDoc}`;

/**
 * __useFinishScheduleDesignPackageMetadataQuery__
 *
 * To run a query within a React component, call `useFinishScheduleDesignPackageMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinishScheduleDesignPackageMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinishScheduleDesignPackageMetadataQuery({
 *   variables: {
 *      id: // value for 'id'
 *      dpRpavId: // value for 'dpRpavId'
 *   },
 * });
 */
export function useFinishScheduleDesignPackageMetadataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FinishScheduleDesignPackageMetadataQuery, FinishScheduleDesignPackageMetadataQueryVariables> & ({ variables: FinishScheduleDesignPackageMetadataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FinishScheduleDesignPackageMetadataQuery, FinishScheduleDesignPackageMetadataQueryVariables>(FinishScheduleDesignPackageMetadataDocument, options);
      }
export function useFinishScheduleDesignPackageMetadataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FinishScheduleDesignPackageMetadataQuery, FinishScheduleDesignPackageMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FinishScheduleDesignPackageMetadataQuery, FinishScheduleDesignPackageMetadataQueryVariables>(FinishScheduleDesignPackageMetadataDocument, options);
        }
export function useFinishScheduleDesignPackageMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FinishScheduleDesignPackageMetadataQuery, FinishScheduleDesignPackageMetadataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FinishScheduleDesignPackageMetadataQuery, FinishScheduleDesignPackageMetadataQueryVariables>(FinishScheduleDesignPackageMetadataDocument, options);
        }
export type FinishScheduleDesignPackageMetadataQueryHookResult = ReturnType<typeof useFinishScheduleDesignPackageMetadataQuery>;
export type FinishScheduleDesignPackageMetadataLazyQueryHookResult = ReturnType<typeof useFinishScheduleDesignPackageMetadataLazyQuery>;
export type FinishScheduleDesignPackageMetadataSuspenseQueryHookResult = ReturnType<typeof useFinishScheduleDesignPackageMetadataSuspenseQuery>;
export type FinishScheduleDesignPackageMetadataQueryResult = Apollo.QueryResult<FinishScheduleDesignPackageMetadataQuery, FinishScheduleDesignPackageMetadataQueryVariables>;